import React, { useState, useEffect } from 'react';
import { FiMail, FiLock } from 'react-icons/fi';
import { Link, useNavigate } from 'react-router-dom';
import { Loading } from 'notiflix/build/notiflix-loading-aio';
import { Notify } from 'notiflix';
import { login } from '../../../services/auth';
import { setToken } from '../../../utils/token';
import { googleAuth } from '../../../services/google';
//ToDo: buradaki inputlar next ui input ile değiştirilcek.
function LoginComponent() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)

  const handleSubmit = async () => {
    try {
      const response = await login({
        email,
        password
      });
      
      
      if (response && response.accessToken) {
        setToken('penatoken', response.accessToken);
        setToken('user', JSON.stringify(response.user));
        Notify.success('Başarıyla giriş yapıldı!');
        navigate('/dashboard');
      } else if (response && response.message) {
        // API'den gelen mesajı göster
        Notify.failure(response.message, { position: 'right-bottom' });
      } else {
        Notify.failure('Bilgilerinizi kontrol ediniz.', { position: 'right-bottom' });
      }
    } catch (error) {
      console.error('Login error:', error);
      
      // API'den gelen hata mesajını kontrol et
      if (error.response && error.response.data && error.response.data.message) {
        Notify.failure(error.response.data.message, { position: 'right-bottom' });
      } else if (error.response && error.response.data && error.response.data.errors) {
        // Validation hatalarını göster
        const errorMessages = Object.values(error.response.data.errors).flat();
        Notify.failure(errorMessages.join(', '), { position: 'right-bottom' });
      } else {
        Notify.failure('Giriş işlemi sırasında bir hata oluştu.', { position: 'right-bottom' });
      }
    }
  }

  const responseGoogle = async () => {
    try {
      Loading.pulse('Google ile giriş yapılıyor...');
      
      // Google OAuth popup aç
      const googleToken = await googleAuth.openGoogleAuthPopup();
      
      // Google token ile giriş yap
      const response = await googleAuth.loginWithGoogle(googleToken);
      
      if (response.success) {
        // Token'ı kaydet
        setToken(response.token);
        
        Notify.success('Google ile giriş başarılı!', { position: 'right-bottom' });
        
        // Dashboard'a yönlendir
        navigate('/dashboard');
      } else {
        Notify.failure(response.message || 'Google ile giriş başarısız!', { position: 'right-bottom' });
      }
    } catch (error) {
      console.error('Google OAuth error:', error);
      
      if (error.message === 'User closed popup') {
        Notify.info('Giriş iptal edildi', { position: 'right-bottom' });
      } else if (error.message === 'Popup blocked') {
        Notify.failure('Popup engellendi. Lütfen popup engelleyicisini kapatın.', { position: 'right-bottom' });
      } else {
        Notify.failure('Google ile giriş sırasında bir hata oluştu.', { position: 'right-bottom' });
      }
    } finally {
      Loading.remove();
    }
  }

  return (
    <div className="h-screen flex lg:flex-row flex-col  bg-[#fdfdfd]">
      <div className="flex lg:w-2/3 w-full justify-center">
        <img src="/assets/loginpg.svg" alt="Logo" className="max-w-[600px] w-full h-auto mr-2 mt-3" />
      </div>

      <div className="flex lg:w-1/3 w-full justify-center items-center bg-white  border-l border-gray-200">
        <div className="bg-white ">
          <h1 className="text-red-600 text-3xl ">Giriş Yap</h1>
          <p className="text-sm font-normal text-gray-600 mb-10 my-4">Giriş yapmak için formu kullanabilirsin.</p>
          <div className="flex w-80 h-[60px] items-center border-2 py-2 px-3 rounded-2xl mb-5">
            <FiMail className="h-5 w-5 text-gray-400" />
            <input onChange={(e) => setEmail(e.target.value)} className="pl-2 outline-none border-none" type="text" name="" id="" placeholder="E-Posta" />
          </div>
          <div className="flex my-4 w-80 h-[60px] items-center border-2 py-2 px-3 rounded-2xl">
            <FiLock className="h-5 w-5 text-gray-400" />
            <input onChange={(e) => setPassword(e.target.value)} className="pl-2 outline-none border-none" type="password" name="" id="" placeholder="Şifre" />
          </div>
          <span className="flex justify-end text-sm ml-2 opacity-50 hover:text-red-600 cursor-pointer">Şifreni mi unuttun?</span>
          <div className="flex justify-between">
            <button onClick={() => handleSubmit()} type="submit" className="block w-[130px] h-[45px] bg-red-600 mt-4 py-2 rounded-2xl text-white font-semibold mb-2">
              Giriş Yap
            </button>

            <div className="flex mt-6 ltr:ml-auto rtl:mr-auto">
              <p className="mr-4 text-gray-800">ya da</p>
              <Link to="/register" className="text-red-600 dark:text-gray-100 hover:text-red-700 dark:hover:text-gray-200 transition-colors">
                Hesap oluştur.
              </Link>
            </div>
          </div>

          {/* Google ile Giriş */}
          <div className="mt-6">
            <div className="relative">
              <div className="absolute inset-0 flex items-center">
                <div className="w-full border-t border-gray-300 dark:border-gray-600"></div>
              </div>
              <div className="relative flex justify-center text-sm">
                <span className="px-2 bg-white dark:bg-dark-300 text-gray-500 dark:text-gray-400">veya</span>
              </div>
            </div>
            
            <button
              onClick={() => responseGoogle()}
              className="mt-4 w-full flex items-center justify-center px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-2xl shadow-sm bg-white dark:bg-gray-800 text-sm font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors duration-200"
            >
              <svg className="w-5 h-5 mr-3" viewBox="0 0 24 24">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
              </svg>
              Google ile Giriş Yap
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
export default LoginComponent
